<!-- Barre de filtres -->
<div class="flex align-items-center justify-content-between flex-none pb-3">
    <p-selectbutton [options]="filterOptions" [(ngModel)]="filter" optionLabel="label" optionValue="value"
        [allowEmpty]="false" size="small" (onChange)="onChangeFilter()"></p-selectbutton>
    <span class="text-color-secondary">{{ visibleCount }} événement{{ visibleCount > 1 ? 's' : '' }}</span>
</div>

<!-- Timeline -->
<div #scrollContainer class="flex-1 overflow-y-auto" (scroll)="onScrollTimeline()">

    <!-- Aucun événement -->
    @if (!loading && !events.length) {
    <div class="text-center text-color-secondary py-5">Aucun événement d'historique</div>
    }

    <p-timeline [value]="timelineItems">

        <!-- Marqueur : pastille de date ou point coloré selon l'origine -->
        <ng-template #marker let-item>
            @if (!!item.date) {
            <span class="surface-100 border-round-3xl px-3 py-1 text-sm font-semibold text-color-secondary white-space-nowrap">
                {{ item.date }}
            </span>
            } @else {
            <span class="border-circle w-1rem h-1rem" [ngClass]="item.dotClass" [pTooltip]="item.timeExact"
                tooltipPosition="top"></span>
            }
        </ng-template>

        <!-- Côté gauche : actions automatiques -->
        <ng-template #opposite let-item>
            @if (!!item.event && item.system) {
            <div class="flex flex-column align-items-end text-left pb-3">
                <div class="text-sm text-color-secondary mb-1" [pTooltip]="item.timeExact" tooltipPosition="top">
                    {{ item.time }}</div>
                <ng-container *ngTemplateOutlet="eventCard; context: { $implicit: item }"></ng-container>
            </div>
            }
        </ng-template>

        <!-- Côté droit : actions manuelles -->
        <ng-template #content let-item>
            @if (!!item.event && !item.system) {
            <div class="flex flex-column align-items-start pb-3">
                <div class="text-sm text-color-secondary mb-1" [pTooltip]="item.timeExact" tooltipPosition="top">
                    {{ item.time }}</div>
                <ng-container *ngTemplateOutlet="eventCard; context: { $implicit: item }"></ng-container>
            </div>
            }
        </ng-template>
    </p-timeline>

    <!-- Chargement -->
    @if (loading) {
    <div class="flex justify-content-center py-3">
        <p-progressSpinner class="w-2rem h-2rem" strokeWidth="6"></p-progressSpinner>
    </div>
    }

    <!-- Fin de l'historique -->
    @if (!hasMore && !!events.length) {
    <div class="text-center text-color-secondary text-sm py-3">
        <div class="border-circle surface-300 w-1rem h-1rem mx-auto mb-2"></div>
        Début de l'historique
    </div>
    }
</div>

<!-- Carte d'un événement (commune aux deux côtés) -->
<ng-template #eventCard let-item>
    <div class="border-1 border-round-2xl surface-card p-3 w-full" [ngClass]="item.borderClass"
        [class.cursor-pointer]="item.event.hasDetails" (click)="onClickEvent(item)">

        <!-- En-tête de la carte -->
        <div class="flex align-items-start gap-2">

            <!-- Grosse icône -->
            <div class="flex align-items-center justify-content-center border-round-xl w-3rem h-3rem flex-none"
                [ngClass]="item.iconBgClass">
                <i [class]="item.icon" [ngClass]="item.iconClass" class="text-lg"></i>
            </div>

            <!-- Contenu de la carte -->
            <div class="flex-1">

                <!-- Titre et sous-titre -->
                <div class="text-lg font-semibold" [ngClass]="item.titleClass">{{ item.title }}</div>
                @if (!!item.subtitle) {
                <div class="text mt-1" [ngClass]="item.subtitleClass">{{ item.subtitle }}</div>
                }

                <!-- Auteur de l'événement -->
                @if (!!item.event.user) {
                <div class="flex align-items-center gap-2 mt-2">
                    @if (item.event.user.system) {} @else if (!!item.event.user.avatar) {
                    <p-avatar [image]="item.event.user.avatar" shape="circle"></p-avatar>
                    } @else {
                    <p-avatar [label]="item.event.user.initials" shape="circle"
                        [style]="{ 'background-color': item.event.user.avatarLabelColor, color: '#ffffff' }"></p-avatar>
                    }
                    <span class="text-color-secondary">{{ item.event.user.fullName }}</span>
                </div>
                }

                <!-- Utilisateur concerné par le statut (ex. statut « lu ») -->
                @if (!!item.event.statusUser) {
                <div class="text-sm text-color-secondary mt-1">Pour {{ item.event.statusUser.fullName }}</div>
                }
            </div>

            <!-- Chevron d'expansion -->
            @if (item.event.hasDetails) {
            <i class="pi text-color-secondary text-xs mt-1"
                [ngClass]="expandedEvent === item.event ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
            }
        </div>

        <!-- Détails dépliés -->
        @if (expandedEvent === item.event) {
        <p-divider></p-divider>
        <div class="flex flex-column gap-2 text-left">
            @if (!!item.event.reason) {
            <div class="text-sm text-color-secondary">{{ item.event.reason }}</div>
            }
            @for (change of item.event.changes; track change.field) {
            <div class="text-sm">
                <div class="text-color-secondary mb-1">{{ change.label }}</div>
                <div class="flex align-items-center gap-2 flex-wrap">
                    <p-tag severity="danger" class="line-through font-normal" [rounded]="true" [value]="change.oldDisplay ?? '—'"></p-tag>
                    <i class="pi pi-arrow-right text-color-secondary text-xs"></i>
                    <p-tag severity="success" class="font-normal" [rounded]="true" [value]="change.newDisplay ?? '—'"></p-tag>
                </div>
            </div>
            }
        </div>
        }
    </div>
</ng-template>
